import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Link, Grid } from 'components/ui';
import TextInput from 'components/Inputs/TextInput/TextInput';
import FormValidator from 'utils/FormValidator';
import ErrorConstants from 'utils/ErrorConstants';
import ErrorsUtils from 'utils/Errors';
import localeUtils from 'utils/LanguageLocale';
import LanguageLocale from 'utils/LanguageLocale';
import { forms } from 'style/config';

function SecondAddressField({
    address2 = '',
    showAddress2Input = false,
    isAdsRestricted = false,
    isFCFinalReleaseEnabled = false,
    isSubscription = false,
    modalTitle = '',
    localization = {},
    onChange,
    onKeyUp,
    onAddAddress2Click,
    address2InputRef,
    fireFormErrorAnalytics,
    forceSingleColumn
}) {
    const { address2LabelText, optional, add } = localization;
    const isUS = localeUtils.isUS();

    const maxLengthVal = FormValidator.FIELD_LENGTHS.addressAdsRestricted;
    const frenchLabelAsOptional = isUS && LanguageLocale.isFrench() && address2LabelText.substring(0, 39);

    const address2Label = !isUS && !isFCFinalReleaseEnabled ? address2LabelText : `${frenchLabelAsOptional || address2LabelText} ${optional}`;

    const validateAddress2 = address => {
        if (!FormValidator.isValidLength(address, 0, maxLengthVal)) {
            if (isSubscription && fireFormErrorAnalytics) {
                const errorCode = isAdsRestricted ? ErrorConstants.ERROR_CODES.ADDRESS1_ADS_LONG : ErrorConstants.ERROR_CODES.ADDRESS1_LONG;
                fireFormErrorAnalytics(modalTitle, ErrorsUtils.getMessage(errorCode));
            }

            return isAdsRestricted ? ErrorConstants.ERROR_CODES.ADDRESS1_ADS_LONG : ErrorConstants.ERROR_CODES.ADDRESS1_LONG;
        }

        return null;
    };

    return (
        <React.Fragment>
            <div style={showAddress2Input ? { display: 'none' } : null}>
                <Link
                    aria-expanded={showAddress2Input}
                    aria-controls='address2_section'
                    onClick={onAddAddress2Click}
                    display='block'
                    lineHeight='tight'
                    color='blue'
                    marginBottom={forms.MARGIN_BOTTOM}
                    children={`${add} ${address2LabelText}`}
                />
            </div>
            <Grid
                id='address2_section'
                style={!showAddress2Input ? { display: 'none' } : null}
                gridTemplateColumns={forceSingleColumn ? '1fr' : ['100%', '1fr 1fr']}
            >
                <TextInput
                    name='address2'
                    autoComplete='address-line2'
                    autoCorrect='off'
                    onChange={onChange}
                    onKeyUp={onKeyUp}
                    label={address2Label}
                    ref={address2InputRef}
                    maxLength={maxLengthVal}
                    value={address2}
                    validateError={validateAddress2}
                    data-at={Sephora.debug.dataAt('address_line_2')}
                />
            </Grid>
        </React.Fragment>
    );
}

export default wrapFunctionalComponent(SecondAddressField, 'SecondAddressField');
